/**
 * THE GENERATED-MEDIA CLIENT — what the evidence bucket actually holds.
 *
 * THE LIBRARY IS A STORE READ, NOT A SECOND INDEX. A file appears here exactly
 * when its write succeeded; an artifact whose bucket was absent or refused the
 * write never appears, and the receipt that named it says the same thing. That
 * is why this client asks for a page and a cursor rather than carrying a list
 * of descriptors the workspace copied at generation time.
 *
 * THE BYTE URL IS A PLAIN URL, NOT A GATEWAY READ. `readGateway` parses the
 * JSON envelope every `/api/scout` route answers with; an image or an audio
 * element cannot. The session is still the edge's cookie, and the route
 * re-checks the owner prefix, so the URL is a request for one file and not a
 * capability.
 */

import { readGateway, type GatewayResult } from './gateway';

export type MediaKind = 'IMAGE' | 'VIDEO' | 'AUDIO';

export interface MediaArtifact {
	key: string;
	mediaType: string;
	kind: MediaKind | null;
	bytes: number;
	sha256: string | null;
	uploadedAt: string | null;
	provider: string | null;
	model: string | null;
	promptHash: string | null;
	runId: string | null;
	spaceId: string | null;
	trialId: string | null;
	purpose: string | null;
}

export interface MediaLibraryPage {
	/** False means this deployment has no artifact store at all — a deployment
	 *  fact, not an empty library. */
	available: boolean;
	/** Why the page is empty or partial, when it is. */
	reason: string | null;
	artifacts: MediaArtifact[];
	/** The next offset, or null at the end. */
	cursor: string | null;
	/** How many stored objects the read examined. */
	scanned: number;
	/** True when the store holds more than the read scanned. */
	truncated: boolean;
}

export async function listMedia(options: {
	limit?: number;
	cursor?: string | null;
} = {}): Promise<GatewayResult<MediaLibraryPage>> {
	const query = new URLSearchParams();
	if (options.limit !== undefined) query.set('limit', String(options.limit));
	if (options.cursor !== null && options.cursor !== undefined && options.cursor.length > 0) {
		query.set('cursor', options.cursor);
	}
	const suffix = query.toString();
	return readGateway<MediaLibraryPage>(
		`/api/scout/gateway/media${suffix.length === 0 ? '' : `?${suffix}`}`,
	);
}

/** The URL an `<img>`, `<audio>` or `<video>` element loads. `download`
 *  requests an attachment disposition instead of inline rendering. */
export function mediaFileUrl(key: string, options: { download?: boolean } = {}): string {
	const query = new URLSearchParams({ key });
	if (options.download === true) query.set('download', '1');
	return `/api/scout/gateway/media/file?${query.toString()}`;
}
